import React from 'react';
import styled from 'styled-components';
import { Wrapper, Menu, MenuItem } from 'react-aria-menubutton';
import { v4 as uuidv4 } from 'uuid';
import { Trigger } from './Trigger';
const StyledMenu = styled(Menu) `
  ${({ theme: { space } }) => `
    & > button, > a {
      padding-left: ${space.lg};
    }
    & > button:last-child, > a:last-child  {
      border-bottom: none;
    }
  `}
`;
const StyledMenuItem = styled(MenuItem)(({ theme: { colors }, $isOpen }) => `
    border-bottom: 1px solid ${colors['slate-3']};
    cursor: pointer;
    
    &:hover {
      background-color: ${$isOpen ? colors.white : colors['patina-1']};
    }
  `);
const SubMenu = ({ triggerContent, children, withAllyTM, ariaLabel, disableCloseOnBlur = false, }) => {
    const { current: wrapperId } = React.useRef(`menu-wrapper-${uuidv4()}`);
    const [isOpen, setIsOpen] = React.useState(false);
    const handleMenuToggle = ({ isOpen: isMenuOpen, }) => {
        setIsOpen(isMenuOpen);
    };
    return (React.createElement(StyledMenuItem, { "$isOpen": isOpen },
        React.createElement(Wrapper, { onMenuToggle: handleMenuToggle, id: wrapperId, closeOnBlur: !disableCloseOnBlur },
            React.createElement(Trigger, { isOpen: isOpen, content: triggerContent, wrapperId: wrapperId, withAllyTM: withAllyTM, ariaLabel: ariaLabel }),
            React.createElement(StyledMenu, null,
                React.createElement(React.Fragment, null, children)))));
};
export default SubMenu;
//# sourceMappingURL=index.js.map